import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { ObserversStoreState } from '@/store/observers/observers.types'

export const useObserversStore = defineStore(StoreId.OBSERVERS, {
  state: (): ObserversStoreState => ({
    categoryListState: false,
  }),
  actions: {
    setCategoryListState(state: boolean) {
      this.categoryListState = state
    },
  },
})
